<template>
  <div style="position: relative;">
    <div class="BaseCollapse" ref="baseCollapse" style="overflow: hidden; will-change: height;">
      <div ref="calcWrapper">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { TweenLite } from 'gsap'

export default {
  inject: ['$validator'],
  props: {
    collapse: Boolean,
    changeHeight: [ String, Array, Object, Boolean, Number ],
    transitionDuration: {
      type: Number,
      default: 0.3 // [seconds]
    }
  },
  watch: {
    collapse(val) {
      this.setCollapse(val)
    },
    changeHeight (val) {
      this.setCollapse(false)
    }
  },
  methods: {
    mHeight () {
      const { calcWrapper } = this.$refs

      if (!calcWrapper) {
        return
      }

      calcWrapper.style.position = 'absolute'
      calcWrapper.style.display = 'block'
      calcWrapper.style.height = 'auto'
      calcWrapper.style.visibility = 'hidden'

      const h = calcWrapper.clientHeight

      calcWrapper.style.position = null
      calcWrapper.style.display = null
      calcWrapper.style.visibility = null

      return h
    },
    expandContent () {
      TweenLite.to(this.$refs.baseCollapse, this.transitionDuration, {
        height: () => `${this.mHeight()}px`,
        onStart: () => {
          this.$refs.baseCollapse.style.opacity = '1'
        },
      })
    },
    collapseContent () {
      TweenLite.to(this.$refs.baseCollapse, this.transitionDuration, {
        height: '0px',
        onComplete: () => this.$refs.baseCollapse.style.opacity = '0'
      })
    },
    setCollapse (val) {
      if(!val) {
        this.expandContent()
      } else {
        this.collapseContent()
      }
    }
  },
  created () {

  },
  mounted () {
    if(this.collapse === true){
      this.$refs.baseCollapse.style.height = '0px'
    }
    this.setCollapse(this.collapse)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseCollapse.vue